// Module
var code = "<md-icon class=\"o-move-tool-1\" ui-tree-handle></md-icon> <span>{{hierarchy.description}}</span> <div ui-tree-nodes=\"\" ng-model=\"hierarchy.children\"> <div ng-repeat=\"hierarchy in hierarchy.children\" ui-tree-node ng-include=\"$ctrl.templateNested\"></div> </div> ";
// Exports
var _module_exports =code;;
var path = 'routes/admin/hierarchies/hierarchies.sort.nested.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;